/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Button, Grid } from '@material-ui/core'
import { getManagementSoilsPracticesByForm } from '../../../../../services/Elegibilidad/get'
import { updateManagementSoilsPractices } from '../../../../../services/Elegibilidad/put'
import swal from 'sweetalert'
import { insertManagementSoilsPractices } from '../../../../../services/Elegibilidad/create'
import { deleteManagementSoilsPractices } from '../../../../../services/Elegibilidad/delete'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useEligibility } from '../../../../../context/EligibilityContext'

const Table399 = ({
  idElegibilityForm,
  formik,
  setLoadingTables,
  loadingTables,
}) => {
  const [state, dispatch] = useEligibility()
  const [tableData, setTableData] = useState([])
  const [addOther, setAddOher] = useState(true)
  let PreviouslyImplemented = null

  const getDataTable = async () => {
    try {
      const response = await getManagementSoilsPracticesByForm(
        idElegibilityForm,
      )

      if (response.Success) {
        setTableData(response.Data)

        if (setLoadingTables) {
          setLoadingTables(false)
        }

        const resultValidate = response.Data.filter(
          (obj) => obj.PreviouslyImplemented,
        )

        if (resultValidate.length >= 1)
          formik.setFieldValue('validTable399', true)
        else {
          formik.setFieldValue('validTable399', false)
        }

        const result = response.Data.filter(
          (obj) => obj.IdAdaptationPractice === 1,
        )
        if (result.length === 0) setAddOher(true)
        else {
          setAddOher(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const handleActualizar = async (data) => {
    const body = {
      IdElegibilityAnswer: data.IdElegibilityAnswer,
      IdAdaptationPractice: data.IdAdaptationPractice,
      AdaptationPracticeDetail: data.AdaptationPracticeDetail,
      PreviouslyImplemented: PreviouslyImplemented,
      Men: Number(data.Men),
      Women: Number(data.Women),
      isDefault: data.isDefault,
    }
    const response = await updateManagementSoilsPractices(body)
    if (response.Success) {
      getDataTable()
      PreviouslyImplemented = null
    }
  }

  const handleGuardar = async (data) => {
    const body = {
      IdElegibilityAnswer: idElegibilityForm,
      IdAdaptationPractice: 1,
      AdaptationPracticeDetail: data.AdaptationPracticeDetail,
      PreviouslyImplemented: PreviouslyImplemented,
      Men: Number(data.Men),
      Women: Number(data.Women),
      isDefault: false,
    }
    const response = await insertManagementSoilsPractices(body)
    if (response.Success) {
      swal({
        title: '¡Datos Agregados exitosamente!',
        icon: 'success',
      })
      getDataTable()
      PreviouslyImplemented = null
    }
  }

  const handleDelete = async (id) => {
    const body = {
      IdElegibilityAnswer: idElegibilityForm,
      IdAdaptationPractice: id,
    }
    try {
      await deleteManagementSoilsPractices(body)
      getDataTable()
    } catch (error) {
      console.log(error)
    }
  }

  const alertValidationFields = () => {
    swal({
      title:
        'Debe ingresar la cantidad de hombres y mujeres que han implementado la práctica de adaptación',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const columns = [
    {
      title: 'Prácticas de adaptación',
      field: 'AdaptationPracticeDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'onAdd',
      // validate: (rowData) =>
      //   rowData.AdaptationPracticeDetail === '' ||
      //   rowData.AdaptationPracticeDetail === null ||
      //   rowData.AdaptationPracticeDetail?.length > 200
      //     ? 'La práctica no puede ir vacia y máximo 200 caracteres'
      //     : '',
      validate: (rowData) =>
        rowData.AdaptationPracticeDetail === '' ||
        rowData.AdaptationPracticeDetail === null ||
        rowData.AdaptationPracticeDetail === undefined ||
        rowData.AdaptationPracticeDetail?.length > 100
          ? {
              isValid: false,
              helperText: 'Este campo es obligatorio (máximo 100 caracteres)',
            }
          : true,
    },
    {
      title: 'Seleccione si se ha implementado antes en la MIPYME',
      field: 'PreviouslyImplemented',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (PreviouslyImplemented === null) {
          PreviouslyImplemented = props.value
        }
        return (
          <Grid style={{ marginLeft: '38%' }}>
            <input
              type="checkbox"
              id="checkMen"
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  PreviouslyImplemented = true
                } else {
                  PreviouslyImplemented = false
                }
              }}
            />
          </Grid>
        )
      },
    },
    {
      title:
        '¿Cuántos hombres empleados han implementado esta medida, dentro de la MIPYME?',
      field: 'Men',
      sorting: false,
      filtering: false,
      type: 'numeric',
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },

      align: 'center',
      validate: (rowData) =>
        rowData.Men === '' ||
        rowData.Men === null ||
        rowData.Men === undefined ||
        rowData.Men?.length > 5
          ? {
              isValid: false,
              helperText: 'Este campo es obligatorio (Máximo 5 cifras)',
            }
          : true,
    },
    {
      title:
        '¿Cuántas mujeres empleadas han implementado esta medida, dentro de la MIPYME?',
      field: 'Women',
      type: 'numeric',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      align: 'center',
      // type: 'numeric',
      validate: (rowData) =>
        rowData.Women === '' ||
        rowData.Women === null ||
        rowData.Women === undefined ||
        rowData.Women?.length > 5
          ? {
              isValid: false,
              helperText: 'Este campo es obligatorio (Máximo 5 cifras)',
            }
          : true,

      // validate: (rowData) =>
      //   rowData.Women?.length > 5 ? 'Máximo 5 cifras' : '',
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            actions={[
              !addOther
                ? {
                    icon: () => (
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddIcon style={{ color: 'white' }} />}
                        disabled
                      >
                        Agregar práctica
                      </Button>
                    ),
                    tooltip: 'Agregar',
                    position: 'toolbar',
                  }
                : null,
            ]}
            editable={{
              isDeleteHidden: (rowData) => rowData.IdAdaptationPractice !== 1,

              onRowAdd: addOther
                ? (newRow) =>
                    new Promise((resolve, reject) => {
                      if (
                        newRow.Men !== null &&
                        newRow.Women !== null &&
                        (newRow.Men !== 0 || newRow.Women !== 0)
                      ) {
                        handleGuardar(newRow)
                      } else {
                        alertValidationFields()
                      }
                      setTimeout(() => resolve(), 500)
                    })
                : null,
              onRowUpdate: (newData, oldData, rowData) =>
                new Promise((resolve, reject) => {
                  if (PreviouslyImplemented === true)
                    if (
                      newData.Men !== null &&
                      newData.Women !== null &&
                      (newData.Men !== 0 || newData.Women !== 0)
                    ) {
                      handleActualizar(newData)
                    } else {
                      alertValidationFields()
                    }
                  resolve()
                  setTimeout(() => {}, 1000)
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  handleDelete(oldData.IdAdaptationPractice)
                  setTimeout(() => resolve(), 500)
                }),
            }}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Add: () => (
                <Button
                  variant="contained"
                  style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                  startIcon={<AddIcon style={{ color: 'white' }} />}
                >
                  Agregar práctica
                </Button>
              ),
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table399)
